<template>
<canvas id="ChartWithLine" width="300" height="200"></canvas>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import { range } from 'lodash';
Chart.register(...registerables);

export default {
    name: 'LineChart',
    props: {
        chartData: Object,
        lineIndex: Array,
    },
    data() {
        return {
            chartOptions: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                },
                responsive: false,
                maintainAspectRatio: false,
            }
        };
    },
    watch: {
        lineIndex() {
            this.myChart.destroy()
            this.drawLine();
        }
    },
    methods: {
        drawLine() {
            const lineAtIndex = this.lineIndex;
            const ctx = document.getElementById('ChartWithLine').getContext('2d');
            const arbitraryLine = {
                id: 'arbitrayLine',
                beforeDraw(chart){
                    const { ctx, chartArea: { top, bottom }, scales:{ x }} = chart;
                    ctx.save();
                    ctx.strokeStyle = 'LightGrey';
                    for (let i in range((lineAtIndex.length)-1)) {
                        ctx.strokeRect(x.getPixelForValue(lineAtIndex[i]-1), top, 0, bottom - 25);
                    };
                    ctx.restore();
                }
            };
            this.myChart = new Chart(ctx , {
                type: 'line',
                data: this.chartData,
                options: this.chartOptions,
                plugins: [arbitraryLine]
            });
        }
    },
    mounted() {
        this.drawLine();
    }
};
</script>
